import { useEffect } from "react";
import { Link } from "react-router";
import { INTERNAL_DESKS } from "./internalDesks.js";
import "../provider/ProviderGuide.scss";
import "../home/HomeGuide.scss";
import "./InternalGuide.scss";

const Card = ({ to, img, alt, kicker, name, detail }) => (
    <Link to={to} className="provider-guide__card home-guide__card">
        <img src={img} alt={alt} />
        <span>{kicker}</span>
        <em>{detail}</em>
        <strong>{name}</strong>
    </Link>
);

const InternalGuide = () => {
    useEffect(() => {
        const root = document.querySelector(".container.provider-guide");
        if (!root) return undefined;
        const nodes = root.querySelectorAll("[data-reveal]");
        const reveal = () => {
            const viewTop = root.scrollTop;
            const viewBottom = viewTop + root.clientHeight;
            nodes.forEach((node) => {
                const top = node.offsetTop;
                const bottom = top + node.offsetHeight;
                if (bottom > viewTop + 24 && top < viewBottom - 24) node.classList.add("is-in");
            });
        };
        reveal();
        root.addEventListener("scroll", reveal, { passive: true });
        window.addEventListener("resize", reveal);
        return () => {
            root.removeEventListener("scroll", reveal);
            window.removeEventListener("resize", reveal);
        };
    }, []);

    return (
        <div className="container provider-guide home-guide">
            <div className="provider-guide__frame">
                <header className="provider-guide__intro" data-reveal>
                    <p className="provider-guide__eyebrow">Internal</p>
                    <h1>How an account gets here</h1>
                    <p>
                        Home is the plan once it is running. Internal is the handoff
                        before that. The same employer is written once. Each desk adds
                        its own piece.
                    </p>
                </header>

                <section className="home-guide__section" data-reveal>
                    <header>
                        <p className="provider-guide__eyebrow">One account</p>
                        <h2>Desk to desk</h2>
                        <p>
                            Underwriting quotes the rates and stop-loss. The proposal
                            sets the current plan next to Centivo. Sales records the
                            benefit plan they bought.                             Client success adds contacts,
                            address, bank accounts, and vendors. Legal copies the signed stop-loss
                            onto the account. <Link to="/internal/services">Services</Link> holds
                            the CPT, HCPCS, and revenue codes, and the notes for how
                            a plan prices each service. Admin opens the same
                            account. Each desk’s own form comes later.
                        </p>
                    </header>
                    <ol className="home-guide__grid">
                        {INTERNAL_DESKS.map((desk) => (
                            <li key={desk.id}>
                                <Card
                                    to={desk.to}
                                    img={desk.img}
                                    alt={desk.alt}
                                    kicker={desk.kicker}
                                    detail={desk.detail}
                                    name={desk.name}
                                />
                            </li>
                        ))}
                    </ol>
                </section>

                <section className="home-guide__section" data-reveal>
                    <header>
                        <p className="provider-guide__eyebrow">What moves</p>
                        <h2>Each desk writes one thing</h2>
                    </header>
                    <ol className="internal-guide__writes">
                        {INTERNAL_DESKS.map((desk) => (
                            <li key={`${desk.id}-writes`}>
                                <Link to={desk.to} className="home-guide__hub">
                                    <img src={desk.img} alt="" />
                                    <div>
                                        <span>{desk.label}</span>
                                        <strong>{desk.name}</strong>
                                        <p>{desk.writes}</p>
                                    </div>
                                </Link>
                            </li>
                        ))}
                    </ol>
                </section>
            </div>
        </div>
    );
};

export default InternalGuide;
